import { Project, Task } from '../types/Project';

// テンプレート用の案件データ
export const templateProjects: Project[] = [
  {
    id: 'project-1',
    name: 'Webサイトリニューアルプロジェクト',
    description: 'コーポレートサイトの全面リニューアル。モダンなデザインとレスポンシブ対応を実装。',
    startDate: new Date('2024-01-15'),
    endDate: new Date('2024-04-30'),
    status: 'in-progress',
    progress: 65,
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-02-15')
  },
  {
    id: 'project-2',
    name: 'モバイルアプリ開発',
    description: 'iOS・Android対応のネイティブアプリ開発。ユーザー管理とプッシュ通知機能を含む。',
    startDate: new Date('2024-02-01'),
    endDate: new Date('2024-06-15'),
    status: 'in-progress',
    progress: 35,
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-02-20')
  },
  {
    id: 'project-3',
    name: 'データ分析基盤構築',
    description: 'ビッグデータの収集・分析・可視化を行うためのデータ基盤を構築。',
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-07-31'),
    status: 'planning',
    progress: 15,
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-02-25')
  },
  {
    id: 'project-4',
    name: 'セキュリティ強化プロジェクト',
    description: '既存システムのセキュリティ監査と脆弱性対応。多要素認証の導入。',
    startDate: new Date('2023-11-01'),
    endDate: new Date('2024-01-31'),
    status: 'completed',
    progress: 100,
    createdAt: new Date('2023-10-15'),
    updatedAt: new Date('2024-01-31')
  }
];

// テンプレート用のタスクデータ
export const templateTasks: Task[] = [
  // Webサイトリニューアルプロジェクトのタスク
  {
    id: 'task-1-1',
    projectId: 'project-1',
    name: '要件定義・設計',
    description: 'サイト構成、機能要件、デザイン要件の定義',
    startDate: new Date('2024-01-15'),
    endDate: new Date('2024-01-31'),
    status: 'completed',
    progress: 100,
    assignee: '田中太郎',
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-31')
  },
  {
    id: 'task-1-2',
    projectId: 'project-1',
    name: 'デザイン制作',
    description: 'ワイヤーフレーム、デザインカンプの作成',
    startDate: new Date('2024-02-01'),
    endDate: new Date('2024-02-28'),
    status: 'completed',
    progress: 100,
    assignee: '佐藤花子',
    dependencies: ['task-1-1'],
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-02-28')
  },
  {
    id: 'task-1-3',
    projectId: 'project-1',
    name: 'フロントエンド開発',
    description: 'HTML/CSS/JavaScriptによる画面実装',
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-04-15'),
    status: 'in-progress',
    progress: 70,
    assignee: '鈴木一郎',
    dependencies: ['task-1-2'],
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-03-20')
  },
  {
    id: 'task-1-4',
    projectId: 'project-1',
    name: 'バックエンド開発',
    description: 'CMS連携、データベース設計・実装',
    startDate: new Date('2024-03-15'),
    endDate: new Date('2024-04-20'),
    status: 'in-progress',
    progress: 45,
    assignee: '山田次郎',
    dependencies: ['task-1-1'],
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-03-25')
  },
  {
    id: 'task-1-5',
    projectId: 'project-1',
    name: 'テスト・デプロイ',
    description: '動作テスト、パフォーマンステスト、本番環境デプロイ',
    startDate: new Date('2024-04-15'),
    endDate: new Date('2024-04-30'),
    status: 'not-started',
    progress: 0,
    assignee: '田中太郎',
    dependencies: ['task-1-3', 'task-1-4'],
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-10')
  },

  // モバイルアプリ開発のタスク
  {
    id: 'task-2-1',
    projectId: 'project-2',
    name: 'アプリ要件定義',
    description: '機能仕様、画面設計、API設計の策定',
    startDate: new Date('2024-02-01'),
    endDate: new Date('2024-02-20'),
    status: 'completed',
    progress: 100,
    assignee: '高橋美咲',
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-02-20')
  },
  {
    id: 'task-2-2',
    projectId: 'project-2',
    name: 'UIデザイン',
    description: 'モバイル向けUIデザインの作成',
    startDate: new Date('2024-02-15'),
    endDate: new Date('2024-03-15'),
    status: 'completed',
    progress: 100,
    assignee: '佐藤花子',
    dependencies: ['task-2-1'],
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-03-15')
  },
  {
    id: 'task-2-3',
    projectId: 'project-2',
    name: 'iOS開発',
    description: 'iOS向けネイティブアプリの開発',
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-05-31'),
    status: 'in-progress',
    progress: 40,
    assignee: '渡辺健太',
    dependencies: ['task-2-2'],
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-03-30')
  },
  {
    id: 'task-2-4',
    projectId: 'project-2',
    name: 'Android開発',
    description: 'Android向けネイティブアプリの開発',
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-05-31'),
    status: 'in-progress',
    progress: 35,
    assignee: '小林純子',
    dependencies: ['task-2-2'],
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-03-30')
  },
  {
    id: 'task-2-5',
    projectId: 'project-2',
    name: 'API開発',
    description: 'バックエンドAPI、ユーザー管理機能の開発',
    startDate: new Date('2024-03-15'),
    endDate: new Date('2024-05-15'),
    status: 'in-progress',
    progress: 25,
    assignee: '山田次郎',
    dependencies: ['task-2-1'],
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-04-01')
  },

  // データ分析基盤構築のタスク
  {
    id: 'task-3-1',
    projectId: 'project-3',
    name: 'アーキテクチャ設計',
    description: 'データパイプライン、分析基盤の設計',
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-03-31'),
    status: 'in-progress',
    progress: 60,
    assignee: '中村雅之',
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-03-20')
  },
  {
    id: 'task-3-2',
    projectId: 'project-3',
    name: 'データ収集基盤',
    description: 'ログ収集、ETL処理の実装',
    startDate: new Date('2024-04-01'),
    endDate: new Date('2024-05-31'),
    status: 'not-started',
    progress: 0,
    assignee: '森田直樹',
    dependencies: ['task-3-1'],
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-02-20')
  },
  {
    id: 'task-3-3',
    projectId: 'project-3',
    name: 'ダッシュボード開発',
    description: 'データ可視化ダッシュボードの開発',
    startDate: new Date('2024-06-01'),
    endDate: new Date('2024-07-31'),
    status: 'not-started',
    progress: 0,
    assignee: '佐藤花子',
    dependencies: ['task-3-2'],
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-02-20')
  },

  // セキュリティ強化プロジェクトのタスク（完了済み）
  {
    id: 'task-4-1',
    projectId: 'project-4',
    name: 'セキュリティ監査',
    description: '既存システムの脆弱性調査',
    startDate: new Date('2023-11-01'),
    endDate: new Date('2023-11-30'),
    status: 'completed',
    progress: 100,
    assignee: '藤井康平',
    createdAt: new Date('2023-10-15'),
    updatedAt: new Date('2023-11-30')
  },
  {
    id: 'task-4-2',
    projectId: 'project-4',
    name: '多要素認証導入',
    description: 'MFA機能の設計・実装',
    startDate: new Date('2023-12-01'),
    endDate: new Date('2024-01-15'),
    status: 'completed',
    progress: 100,
    assignee: '高橋美咲',
    dependencies: ['task-4-1'],
    createdAt: new Date('2023-10-15'),
    updatedAt: new Date('2024-01-15')
  },
  {
    id: 'task-4-3',
    projectId: 'project-4',
    name: '脆弱性対応',
    description: '検出された脆弱性の修正',
    startDate: new Date('2023-12-15'),
    endDate: new Date('2024-01-31'),
    status: 'completed',
    progress: 100,
    assignee: '山田次郎',
    dependencies: ['task-4-1'],
    createdAt: new Date('2023-10-15'),
    updatedAt: new Date('2024-01-31')
  }
];

// テンプレートデータをロードする関数
export const loadTemplateData = () => {
  return {
    projects: templateProjects,
    tasks: templateTasks
  };
};
